export const INVOICE_EMAIL_MESSAGE_DEFAULT = import.meta.env.VITE_INVOICE_EMAIL_MESSAGE_DEFAULT || 'Here is a copy of your invoice.';
